var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 28,
    viewBox: "0 0 69 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2830_805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9879 28L62.4785 0H58.4225L62.6286 17.4553H56.4069L55.4679 21.3357H63.5551L65.1571 27.9754L68.9879 28Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3545 0L49.6849 19.4017L44.6528 0L40.8222 0.0369541L36.1653 19.3894L31.1205 0L27.2899 0.0369541L22.6331 19.4017L17.6007 0L13.7701 0.0246348L9.11331 19.4017L4.06844 0H0L7.27314 28L11.1037 27.963L15.7605 8.59834L20.7929 28L24.6235 27.9754V27.963L29.2928 8.59834L34.3251 28L38.1557 27.9754V27.963L42.8125 8.59834L47.8451 28L51.6754 27.9754L53.2779 21.3357H53.2905L53.6406 19.8328L58.4104 0H54.3545Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2830_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed7a308a48550e694e1d258687c35bf8.svg";
export { ForwardRef as ReactComponent };